import React from 'react';
import styled from 'styled-components';

import InputWrapper from './InputWrapper';

const StyledInput = styled.input`
  outline: none;
  border: none;
  flex-grow: 1;
  height: 100%;
  width: 100%;
  size: unset;
  font-size: ${({ big }) => big ? '40px' : '20px'};
  font-family: Roboto;
  background-color: transparent;

  border-radius: 6px;

  &:not(:focus) {
    color: #95989A;
  }
`;
StyledInput.displayName = 'StyledInput';

const Icon = styled.img`
  width: 30px;
  margin-left: 8px;
`;
Icon.defaultProps = { alt: 'Search' };
Icon.displayName = 'Icon';

const LIVE_EDIT_DEBOUNCE = 1000;

export default class Input extends React.Component {
  constructor(props) {
    super();

    this.state = {
      focused: false,
      editing: false
    };
  }
  handleClick = () => {
    this.input.focus();
  };
  select = () => {
    this.input.select();
  };
  handleFocus = (e) => {
    this.setState({ focused: true });
    this.props.onFocus && this.props.onFocus(e);
  };
  handleBlur = (e) => {
    this.setState({ focused: false });
    if (this.state.editing) {
      this.setState({ editing: false }, () => {
        this.props.onComplete();
      });
    }
    this.props.onBlur && this.props.onBlur(e);
  };
  handleChange = (e) => {
    if (this.props.onComplete) {
      if (!this.state.editing) {
        this.setState({ editing: true });
      }
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.handleComplete();
      }, LIVE_EDIT_DEBOUNCE);
    }

    this.props.onChange && this.props.onChange(e);
  };
  handleComplete = () => {
    clearTimeout(this.timeout);
    this.setState({ editing: false });
    this.props.onComplete && this.props.onComplete();
  };
  handleKeyDown = (e) => {
    if (this.state.editing) {
      switch (e.which) {
        case 13: // Enter
          this.handleComplete();
          break;
        default:
          break;
      }
    }
  };
  render() {
    const { icon, style, inputStyle, label, big, error, ...rest } = this.props;
    return (
      <InputWrapper
          active={!!rest.value}
          onClick={this.handleClick}
          focused={this.state.focused}
          big={big}
          style={style}
          label={label}
          error={error}
      >
        {this.props.icon && (
          <Icon src={this.props.icon} />
        )}
        <StyledInput
          innerRef={r => this.input = r}
          style={inputStyle}
          big={big}
          { ...rest }
          onKeyDown={this.handleKeyDown}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          placeholder={(this.state.focused || !label) ? rest.placeholder : undefined}
        />
      </InputWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Input/Input.js